export default "__VITE_ASSET__DhmnV7d0__"